/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState } from 'react';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
  DragEndEvent,
  DragOverlay,
  DragStartEvent,
} from '@dnd-kit/core';
import {
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { Button } from '@design-system/components/button/button';
import { LandingPageVM } from '../view-model/viewModel';
import { SectionView } from './SectionView';

export const LandingPageBuilderView = (vm: LandingPageVM) => {
  const [activeId, setActiveId] = useState<string | null>(null);

  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
  );

  const handleDragStart = (event: DragStartEvent) =>
    setActiveId(event.active.id as string);

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    setActiveId(null);

    if (!over || active.id === over.id) return;

    const oldIndex = vm.sections.findIndex((s) => s.id === active.id);
    const newIndex = vm.sections.findIndex((s) => s.id === over.id);

    if (oldIndex === -1 || newIndex === -1) return;

    const newSections = [...vm.sections];
    const [removed] = newSections.splice(oldIndex, 1);
    newSections.splice(newIndex, 0, removed);
    vm.reorderSections(newSections);
  };

  const activeSection = activeId
    ? vm.sections.find((s) => s.id === activeId)
    : null;
  return (
    <div>
      <div style={{ marginBottom: '16px', display: 'flex', gap: '8px' }}>
        <Button onClick={vm.checkAll}>Check</Button>
        <Button onClick={vm.saveAll}>Save</Button>
      </div>

      <DndContext
        sensors={sensors}
        collisionDetection={closestCenter}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
      >
        <SortableContext
          items={vm.sections.map((s) => s.id)}
          strategy={verticalListSortingStrategy}
        >
          {vm.sections.map((section) => (
            <SectionView key={section.id} section={section} vm={vm} />
          ))}
        </SortableContext>

        <DragOverlay>
          {activeSection ? (
            <SectionView
              key={activeSection.id}
              section={activeSection}
              vm={vm}
            />
          ) : null}
        </DragOverlay>
      </DndContext>
    </div>
  );
};
